import { userAvatar, companyAvatar } from 'Services/avatarGenerator'
import parse from 'date-fns__legacy__/parse'
import format from 'date-fns__legacy__/format'
import isNull from 'lodash/isNull'
import truncate from 'lodash/truncate'
import { ApiCompanyProfile } from 'Types'

/**
 * @param {ApiCompanyProfilePhoto} data
 * @returns {CompanyProfileMedia}
 */
const parseMedia = (data) => ({
  description: data.caption,
  source: data.imageMediumPath,
  width: data.widthImageMedium,
  height: data.heightImageMedium,
})

const parseWebsite = (url: string): string => {
  return url
    .split('://').pop()
    .split('javascript:').pop()
    .split('data:').pop()
}

export const parseProfile = (data: ApiCompanyProfile): object => {
  const isNotEmpty = str => str !== ''

  const serviceList = data.serviceTypes || []
  const differentialList = data.differential || []
  const referenceList = data.reference || []

  const info = {
    id: data.id,
    idSnet: data.idSnet || 0,
    name: data.fancyName,
    description: truncate(serviceList.join(' | '), { length: 200 }),
    slug: data.slug,
    logo: companyAvatar(data.logoSmallPath, data.fancyName),
    about: data.about ? data.about.trim() : '',
    services: data.servicesDescription ? data.servicesDescription.trim() : '',
    advantanges: differentialList.filter(isNotEmpty),
    endorsements: referenceList.filter(isNotEmpty),
    website: data.site ? parseWebsite(data.site) : null,
    phone: {
      ddd: data.ddd,
      number: data.phone,
    },
    is360Partner: data.is360Partner,
    participationIndex: data.participation.reputation,
    isVerified: data.isVerified
  }

  const visibility = {
    quotation: data.showQuotationButton,
    phone: data.showPhone,
    website: data.showPhone && data.site && data.site.length,
  }

  const rating = {
    score: isNull(data.rating) ? null : parseFloat(data.rating),
    opnions: data.totalEvaluation,
  }

  const location = {
    zipcode: data.zipCode,
    city: data.city,
    state: data.state,
    neighborhood: data.neighborhood,
    address: data.street,
    number: data.number,
    details: data.complement || '',
  }

  const photoGallery = data.photoGallery || []
  const mediaList = photoGallery.map(parseMedia)

  return {
    info,
    visibility,
    rating,
    location,
    mediaList,
  }
}

export const parseQuestions = (data) => {
  return data.map(item => ({
    question: item.question,
    answer: item.answer,
    url: item.url,
    asked: item.asked,
    answered: item.answered,
    author: {
      name: item.author.name,
      avatar: userAvatar(item.author.avatar, item.author.name),
      url: item.author.url,
    },
  }))
}

export const parseReview = data => {
  const reivewDate = parse(data.dateCreated)

  const review = {
    score: parseInt(data.rating) || null,
    comment: data.comment,
    created: format(reivewDate, 'DD/MM/YYYY'),
    updated: data.edited,
  }

  const reply = {
    comment: null,
    created: null,
    updated: false,
  }

  if (data.evaluationReply) {
    const replyDate = parse(data.evaluationReply.dateCreated)

    reply.comment = data.evaluationReply.comment
    reply.created = format(replyDate, 'DD/MM/YYYY')
    reply.updated = data.evaluationReply.edited
  }

  const author = {
    name: data.userName,
    avatar: userAvatar(data.userPhoto, data.userName),
  }

  return { ...review, author, reply }
}

export default {
  parseProfile,
  parseQuestions,
}